import { useState } from 'react'
import { ScoopButton, ScoopSelector, ScoopText, ScoopColumn } from '../../../../ui'
import styles from './MatchFields.module.scss'

export const MatchFields = ({ source, goBack }) => {
    const options = ['First Name', 'Last Name', 'Email']

    return (
        <ScoopColumn className={styles.container}>
            <ScoopText className={styles.headerText}>
                Great, we've got your {source.name} report! Match your report fields to this recipe
            </ScoopText>
            <ScoopColumn className={styles.fieldsContainer}>
                <div className={styles.headerRow}>
                    <ScoopText className={styles.columnHeader}>Recipe Column</ScoopText>
                    <ScoopText className={styles.columnHeader}>Your Report Column</ScoopText>
                </div>
                <MatchingRow column={'First Name'} options={options} />
                <MatchingRow column={'Last Name'} options={options} />
                <MatchingRow column={'Email'} options={options} />
            </ScoopColumn>
            <div className={styles.buttonContainer}>
                <ScoopButton variant="primary" size="small">
                    Continue
                </ScoopButton>
            </div>
        </ScoopColumn>
    )
}

const MatchingRow = ({ column, options }) => {
    const [option, setOption] = useState(options[0] || '')

    const selectorOptions = options.map((opt) => ({ label: opt, value: opt }))

    return (
        <div className={styles.matchingRow}>
            <div className={styles.recipeColumn}>
                <ScoopText className={styles.recipeColumnText}>{column}</ScoopText>
            </div>
            <div className={styles.connector}>
                <div className={styles.connectorLine} />
            </div>
            <div className={styles.selectorWrapper}>
                <ScoopSelector
                    value={option}
                    onChange={(e) => setOption(e.target.value)}
                    options={selectorOptions}
                    size="sm"
                    removeMargin
                />
            </div>
        </div>
    )
}
